export const iconFontAwesomeHumanitarianPersonWalkingArrowRight = (
	<i className="fa-solid fa-person-walking-arrow-right"></i>
);
